
const showHome = () => {
  document.getElementById('app').classList.remove('hasSplashscreen')
  if (!document.getElementById('app').classList.contains('par21')) {
    localStorage.setItem('hasSeenSplashscreen', 'true')
  }
  window.openAd()
  window.setImageMapHeader()
}

export default showHome
